import {
  parseAsIsoDate,
  parseAsString,
  parseAsStringEnum,
  useQueryStates,
} from 'nuqs'

import { Gender } from '@/common/models/person'
import { UserType } from '@/common/models/user'

export function useFilterApplicationAccountUser() {
  return useQueryStates({
    freeSearch: parseAsString,
    userType: parseAsStringEnum(Object.values(UserType)),
    gender: parseAsStringEnum(Object.values(Gender)),
    birthMonth: parseAsString,
    birthYear: parseAsString,
    startCreated: parseAsIsoDate,
    endCreated: parseAsIsoDate,
  })
}
